/**
 * ============================================================================
 *  HUKUKI METINLER — dovizhub-mobile/src/shared/constant/legal.ts KOPYASI.
 *
 *  Metin BIREBIR ayni olmak ZORUNDA: ayni sozlesmenin iki istemcide farkli
 *  yazilmasi, hangi surumun onaylandigini tartismali hale getirir. `legalDocVersion`
 *  onay kaydiyla birlikte sunucuya gidiyor (POST /v1/users/first-login) — metin
 *  degisirse LEGAL_DOC_VERSION IKI ISTEMCIDE BIRDEN artirilmalidir.
 *
 *  Metin i18n katalogunda DEGIL, cunku katalog arayuz metnidir ve cevrilebilir;
 *  bu belge cevrilemez — onaylanan sey Turkce metnin kendisidir. Mobil taraf da
 *  ayni sebeple sabitte tutuyor.
 *
 *  Kanonik uzun hali: monorepo docs/store-release/public/*.md
 * ============================================================================
 */

/**
 * Uygulama içi hukuki metinler (KVKK aydınlatma metni + kullanım koşulları).
 *
 * ────────────────────────────────────────────────────────────────────────────
 *  YAYINA ÇIKMADAN ÖNCE: aşağıdaki COMPANY alanlarını doldurun.
 *  Doldurulmadan mağazaya gönderilirse kullanıcıya "[…]" şeklinde boş alanlar
 *  görünür ve metin hukuken geçersiz olur.
 * ────────────────────────────────────────────────────────────────────────────
 *
 * Bu metinlerin uzun/kanonik hâli monorepo'da tutuluyor:
 *   docs/store-release/public/gizlilik-politikasi.md  (KVKK aydınlatma + gizlilik)
 *   docs/store-release/public/kullanim-kosullari.md   (kullanım koşulları)
 * Metin güncellenirse LEGAL_DOC_VERSION artırılmalı ki hangi sürümün onaylandığı
 * kayıt altına alınabilsin.
 */

export const COMPANY = {
  unvan: 'KURAL FİNANSAL TEKNOLOJİLER YAZILIM VE DANIŞMANLIK A.Ş.',
  adres:
    'Üniversiteler Mahallesi, 1597.Cadde, Bilkent Center AVM, No: 3, İç Kapı No: 104, Zemin Kat,PK: 06800 Bilkent Çankaya/Ankara',
  mersis: '0593130097500001',
  kvkkEmail: 'info@kur-al.com.tr',
  destekEmail: 'info@kur-al.com.tr',
  webSitesi: 'https://kur-al.com.tr',
};

/**
 * Metinler her değiştiğinde artırın; onay kaydıyla birlikte saklanmalıdır. Mobil legal.ts ile
 * AYNI sürüm ve AYNI metin (sürüm geçmişi oradaki notta). * 1.2 → 1.3 (02.10.2026): §5 Talep ve teklif akışı. Teklifler artık geldikçe Müşteri ekranında
 * görünüyor (seçim yine teklif süresi dolunca), seçilmeyen bürolara bildirim gidiyor. Döviz
 * Bürosu sözleşmesi v03 ve Bireysel-Tüzel v02 ile aynı (docs/son-docs). Web aynı anda 1.1'den
 * 1.3'e çıktı: 1.2'deki §3(f) cihaz kimliği beyanı webde eksikti (web de cihaz kimliği
 * üretiyor, kural-app auth/device-id.ts).
 */
export const LEGAL_DOC_VERSION = '1.3';

/**
 * Ekran metinleri. KVKK'nın iki AYRI yükümlülüğünü ayırmak için tek kaynakta toplandı;
 * ekranların fiili ("okudum" mu "kabul ediyorum" mu) buradan gelir.
 *
 *  1) AYDINLATMA (md.10) → KVKK_TEXT.
 *     Bu bir rıza belgesi DEĞİLDİR. Metnin 4. maddesi işlemenin dayanaklarını sözleşmenin
 *     ifası (md.5/2-c), hukuki yükümlülük (md.5/2-ç), meşru menfaat (md.5/2-f) ve hakkın
 *     tesisi (md.5/2-e) olarak sayar — hiçbiri açık rızaya dayanmaz. Dolayısıyla
 *     kullanıcıdan istenen şey "kabul" değil, bilgilendirildiğinin teyididir. Ekranda
 *     "Kabul Ediyorum" yazmak, dayanağı sözleşme olan bir işleme için rıza alınıyormuş
 *     görüntüsü yaratır ve iki kaydı da tartışmalı hâle getirir.
 *
 *  2) SÖZLEŞME → USAGE_AGREEMENT_TEXT.
 *     Bu gerçekten bir sözleşmedir; kabul edilir ve "kabul ediyorum" doğru fiildir.
 *
 *  3) AÇIK RIZA → bugün YOK, bilerek.
 *     KVKK_TEXT md.5 yurt dışı aktarımların "KVKK md.9'da öngörülen mekanizmalara uygun
 *     olarak" yapıldığını beyan ediyor; yani aktarım rızaya dayandırılmıyor. Kullanım
 *     Koşulları md.7 de pazarlama iletilerinin ancak ayrıca onayla gönderileceğini söylüyor
 *     ve bugün böyle bir ileti gönderilmiyor. Ortada alınacak bir açık rıza olmadığı için
 *     üçüncü bir kutu EKLENMEDİ — olmayan bir rızayı toplamak, dayanağı yanlış göstermek olur.
 *
 *     Şu iki durumdan biri doğarsa buraya AYRI ve OPSİYONEL bir kutu eklenmelidir:
 *       (a) md.9 mekanizması (taahhütname/standart sözleşme) fiilen kurulmazsa — aktarımın
 *           dayanağı rızaya döner;
 *       (b) pazarlama/ticari elektronik ileti gönderilecekse (ETK).
 *     Her iki hâlde de kutu ZORUNLU OLMAMALIDIR: kullanmanın şartı hâline getirilen rıza,
 *     özgür iradeyle verilmiş sayılmaz ve geçersizdir.
 */
export const LEGAL_COPY = {
  // Aydınlatma: teyit fiilleri.
  kvkk: {
    title: 'Aydınlatma Metni',
    subtitle: 'Devam etmeden önce lütfen aşağıdaki metni okuyunuz',
    scrollWarning: 'Aydınlatma Metni’ni sonuna kadar okumanız gerekmektedir.',
    scrolledEndLabel: '✓ Metni sonuna kadar okudunuz',
    buttonLabel: 'Okudum, Bilgilendirildim',
    completeDisclaimer:
      'Bu adım bir rıza değildir; yalnızca metni okuduğunuzu teyit eder.',
    incompleteDisclaimer: 'Lütfen metni sonuna kadar okuyunuz',
    goBackTitle: 'Aydınlatma Metni Okunmalı',
    goBackMessage:
      'Aydınlatma Metni’ni okuduğunuzu teyit etmeden devam edemezsiniz. Giriş ekranına dönmek istediğinizden emin misiniz?',
    successMessage: 'Aydınlatma Metni’ni okuduğunuz kaydedilmiştir.',
    errorMessage: 'Kayıt sırasında bir hata oluştu. Lütfen tekrar deneyin.',
  },
  // Sözleşme: kabul fiilleri.
  usage: {
    title: 'Kullanım Koşulları',
    subtitle: 'Devam etmek için lütfen aşağıdaki metni okuyunuz',
    scrollWarning: 'Kullanım Koşulları’nı sonuna kadar okumanız gerekmektedir.',
    scrolledEndLabel: '✓ Metni sonuna kadar okudunuz',
    buttonLabel: 'Kabul Ediyorum',
    completeDisclaimer: 'Kullanım Koşulları’nı kabul etmek için butona basınız',
    incompleteDisclaimer: 'Lütfen metni sonuna kadar okuyunuz',
    goBackTitle: 'Kullanım Koşulları Onayı Gerekli',
    goBackMessage:
      'Kullanım Koşulları’nı kabul etmeden devam edemezsiniz. Giriş ekranına dönmek istediğinizden emin misiniz?',
    successMessage: 'Kullanım Koşulları onayınız kaydedilmiştir.',
    errorMessage: 'Onay sırasında bir hata oluştu. Lütfen tekrar deneyin.',
  },
  // Kayıt ekranındaki iki satır. Fiiller yukarıdaki ayrımı birebir izler.
  signup: {
    kvkkLabel: 'Aydınlatma Metni’ni okudum, bilgilendirildim.',
    kvkkRequired: 'Aydınlatma Metni’ni okuduğunuzu teyit etmelisiniz',
    usageLabel: 'Kullanım Koşulları’nı okudum, kabul ediyorum.',
    usageRequired: 'Kullanım Koşulları’nı kabul etmelisiniz',
    readLink: 'Oku',
    closeLabel: 'Kapat',
    // Shown next to a checkbox that is still locked. The box only unlocks once the matching
    // document has actually been opened and scrolled to the end — the same rule the standalone
    // LegalAgreementScreen already enforces, so the two paths make the same promise about what
    // "okudum" means on the record we store (kvkkAcknowledged + legalDocVersion).
    mustReadFirst: 'Önce metni açıp sonuna kadar okuyun',
    scrollToEnd: 'Metni sonuna kadar kaydırın',
    confirmRead: 'Okudum, kapat',
  },
  // Organizasyon (döviz bürosu) yönetimi ekranlarındaki hukuki metinler.
  organization: {
    // Davet edilen kişi henüz kullanıcı DEĞİL: aydınlatma metnini uygulama içinde görmüyor.
    // KVKK md.10, veriyi başkası girdiğinde de ilgili kişinin bilgilendirilmesini gerektirir;
    // bu metin davetle birlikte paylaşılır ve o boşluğu kapatır.
    inviteNotice: `Bu davet ${COMPANY.unvan} tarafından işletilen DovizHub uygulaması üzerinden gönderilmiştir.

Sizi davet eden işletme, size ulaşabilmek için ad ve e-posta bilginizi uygulamaya girmiştir. Daveti kabul etmezseniz bu bilgi en geç 90 gün içinde silinir.

Daveti kabul ederseniz işletme yöneticisi; ad soyad, e-posta ve telefon bilginizi, işletme içindeki yetkilerinizi ve uygulama üzerinden yaptığınız işlemlerin kaydını görebilir.

Aydınlatma metninin tamamı: ${COMPANY.webSitesi}
Sorularınız için: ${COMPANY.kvkkEmail}`,
    // Yöneticiye, başkasının verisini girdiğini hatırlatır.
    inviteAdminWarning:
      'Davet ettiğiniz kişinin ad ve e-posta bilgisini sisteme siz giriyorsunuz. Daveti gönderirken yukarıdaki bilgilendirme metnini de paylaşınız.',
    // Personele, işlemlerinin yöneticiye görünür olduğunu söyler. Ekranın görünür bir yerinde
    // durmalı: izlemenin gizli olmaması, meşru menfaat dayanağının ön koşulu.
    auditNotice:
      'Bu işletmede yaptığınız yönetimsel işlemler ile verdiğiniz ve kazandığınız tekliflerin sayısı ve tutarı, işletme yöneticisi tarafından görüntülenebilir.',
  },
};

/** COMPANY alanları hâlâ doldurulmamışsa true döner. */
export const hasUnfilledCompanyInfo = (): boolean =>
  Object.values(COMPANY).some(value => value.startsWith('['));


export const KVKK_TEXT = `KİŞİSEL VERİLERİN KORUNMASI HAKKINDA AYDINLATMA METNİ

Bu metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") md.10 uyarınca, DovizHub mobil uygulamasını kullanırken kişisel verilerinizin nasıl işlendiği konusunda sizi bilgilendirmek için hazırlanmıştır.

1. VERİ SORUMLUSU
${COMPANY.unvan}
Adres: ${COMPANY.adres}
MERSİS: ${COMPANY.mersis}
Başvuru e-postası: ${COMPANY.kvkkEmail}

2. DOVIZHUB NE YAPAR?
DovizHub, döviz almak veya satmak isteyen müşteriler ile bu taleplere fiyat teklifi veren döviz büroları arasında bir eşleştirme platformudur. Para transferi uygulama üzerinden yapılmaz; ödeme, tarafların beyan ettiği banka hesapları arasında, uygulama dışında gerçekleşir. DovizHub, kullanıcı adına para veya döviz muhafaza etmez.

3. İŞLENEN KİŞİSEL VERİLER
a) Kimlik: Ad soyad, T.C. kimlik numarası.
b) İletişim: E-posta adresi, telefon numarası, şehir, ilçe.
c) Müşteri işlem / finans: Banka adı, IBAN, hesap adı ve para birimi; oluşturduğunuz döviz talepleri (tutar, döviz cinsi, alış/satış yönü, tarih) ile aldığınız veya verdiğiniz teklifler.
d) Mesleki/ticari (yalnızca döviz bürosu kullanıcıları): İşletme adı, vergi dairesi, vergi numarası, işyeri adresi, şube bilgileri ve işletmenin iletişim bilgileri.
d-1) İşletme üyeliği (yalnızca döviz bürosu kullanıcıları): Bağlı olduğunuz işletme, işletme içindeki rolünüz (yönetici veya personel), size tanınan işlem yetkileri, üyeliğe katılma tarihiniz ve sizi davet eden yöneticinin kimliği.
d-2) İşletme içi işlem kaydı (yalnızca döviz bürosu kullanıcıları): İşletme yöneticisinin görebildiği; yaptığınız yönetimsel işlemler (üye ve yetki değişiklikleri, hesap tanımlama) ile verdiğiniz ve kazandığınız tekliflerin sayısı ve tutarı.
e) Hesap güvenliği: Şifreniz açık metin olarak saklanmaz; yalnızca geri döndürülemez şifreleme özeti (bcrypt) tutulur.
f) İşlem güvenliği: Bildirim gönderebilmek için cihaz bildirim anahtarı ve platform bilgisi; oturumunuzu kullandığınız cihaza bağlayabilmek ve çalınmış bir oturumu fark edebilmek için uygulamanın kurulum sırasında ürettiği bir cihaz kimliği; sistem güvenliği için istek kayıtları ve IP adresi.
g) Onay kayıtları: Bu metni ve Kullanım Koşulları'nı onayladığınız bilgisi ile onay zamanı.

Uygulama; rehberinize, fotoğraflarınıza, kameranıza, mikrofonunuza, SMS ve arama kayıtlarınıza erişmez, konumunuzu toplamaz, reklam kimliğinizi kullanmaz ve sizi başka uygulama veya sitelerde takip etmez.

4. İŞLEME AMAÇLARI VE HUKUKİ SEBEPLERİ
a) Hesabınızın oluşturulması, kimliğinizin doğrulanması ve oturum yönetimi — sözleşmenin kurulması ve ifası (md.5/2-c).
b) Döviz talebinizin oluşturulması, ilgili bürolara iletilmesi ve tekliflerin gösterilmesi — sözleşmenin ifası (md.5/2-c).
c) Ödemenin doğru hesaba yapılabilmesi için banka hesabı bilgilerinizin işlenmesi — sözleşmenin ifası (md.5/2-c).
d) İşlem taraflarının kimliğinin tespiti ve finansal mevzuattan doğan yükümlülüklerin yerine getirilmesi — hukuki yükümlülük (md.5/2-ç).
e) Talep, teklif ve işlem durumu hakkında bildirim gönderilmesi — sözleşmenin ifası (md.5/2-c).
f) Sistem güvenliğinin sağlanması, hataların tespiti ve kötüye kullanımın önlenmesi — meşru menfaat (md.5/2-f).
g) Uyuşmazlık hâlinde hakkın tesisi ve korunması — md.5/2-e.
h) Döviz bürosu hesaplarında işletme yapısının kurulması; personelin yetkilendirilmesi ve yetkilerinin sınırlandırılması — sözleşmenin ifası (md.5/2-c).
i) İşletme içinde kimin hangi yönetimsel işlemi yaptığının kayıt altına alınması ve işletme yöneticisine raporlanması; yetkisiz işlem ve kötüye kullanımın tespiti — meşru menfaat (md.5/2-f). Bu kayıtlar yalnızca işletmenin kendi yöneticisine açıktır ve genel performans değerlendirmesi ya da otomatik karar verme amacıyla kullanılmaz.
j) İşletmeye personel daveti gönderilebilmesi için davet edilen kişinin ad ve e-posta bilgisinin işlenmesi — meşru menfaat (md.5/2-f).

5. AKTARIM
a) İşleminizin karşı tarafına (döviz bürosu veya müşteri): yalnızca bir teklif kabul edildiğinde, işlemin tamamlanabilmesi için ad soyad, iletişim ve seçilen banka hesabı bilgisi. Karşı taraf bir döviz bürosu ise bu bilgiler, o işletmenin yöneticisi ve yönetici tarafından yetkilendirilmiş personeli tarafından görülebilir.
a-1) Bağlı olduğunuz döviz bürosunun yöneticisine (yalnızca büro personeli iseniz): ad soyad, e-posta, telefon, işletme içindeki rolünüz ve yetkileriniz ile 3(d-2)'de belirtilen işletme içi işlem kaydınız.
b) Google (Firebase Cloud Messaging): bildirim gönderimi için cihaz bildirim anahtarı ve bildirim içeriği.
c) E-posta gönderim sağlayıcımız: bilgilendirme ve rapor e-postaları için e-posta adresiniz.
d) Sunucu barındırma sağlayıcımız: sistemde saklanan veriler.
e) Yetkili kamu kurum ve kuruluşları: kanunen talep edilmesi hâlinde (md.8/2, md.28).

Verileriniz pazarlama amacıyla satılmaz, kiralanmaz veya üçüncü taraflara devredilmez. Bildirim altyapısı gibi bazı hizmet sağlayıcılarımızın sunucuları yurt dışında bulunabilir; bu aktarımlar KVKK md.9'da öngörülen mekanizmalara uygun olarak yapılır.

6. TOPLAMA YÖNTEMİ
Veriler; uygulama içindeki kayıt, profil, banka hesabı ve talep formları ile uygulamanın sunucularımızla kurduğu iletişim üzerinden, elektronik ortamda toplanır.

7. SAKLAMA
Hesabınız aktif olduğu sürece; hesabınızı sildiğinizde kimlik ve iletişim bilgileriniz silinir veya geri döndürülemez şekilde maskelenir, banka hesabı bilgileriniz ve bildirim anahtarınız silinir. Mevzuat gereği saklanması zorunlu işlem kayıtları, kimlik bilgilerinizden ayrıştırılarak yasal saklama süresi boyunca tutulur.

Size bir döviz bürosu tarafından personel daveti gönderildiyse ve daveti kabul etmediyseniz, iptal edilen veya süresi dolan davetteki ad ve e-posta bilginiz en geç 90 gün içinde silinir veya anonim hâle getirilir. İşletme içi işlem kayıtları, işletmenin denetim ihtiyacı için 2 yıl saklanır ve süre sonunda silinir.

8. HAKLARINIZ (KVKK md.11)
Kişisel verilerinizin işlenip işlenmediğini öğrenme; işlenmişse bilgi talep etme; işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme; yurt içinde/yurt dışında aktarıldığı üçüncü kişileri bilme; eksik veya yanlış işlenmişse düzeltilmesini isteme; şartları oluştuğunda silinmesini veya yok edilmesini isteme; bu işlemlerin aktarılan üçüncü kişilere bildirilmesini isteme; münhasıran otomatik sistemlerle analiz sonucu aleyhinize bir sonuç doğmasına itiraz etme; kanuna aykırı işleme nedeniyle zarara uğramanız hâlinde zararın giderilmesini talep etme haklarına sahipsiniz.

Başvurularınızı ${COMPANY.kvkkEmail} adresine veya ${COMPANY.adres} adresine iletebilirsiniz; talepleriniz en geç 30 gün içinde ücretsiz olarak sonuçlandırılır.

Hesabınızı ve verilerinizi uygulama içinde Profil ekranındaki "Hesabımı Sil" adımıyla dilediğiniz zaman silebilirsiniz.

9. ÇOCUKLAR
DovizHub 18 yaşından küçüklere yönelik değildir ve 18 yaşından küçüklerden bilerek kişisel veri toplanmaz.

10. DEĞİŞİKLİKLER
Bu metin güncellenebilir. Önemli değişikliklerde uygulama içinde bilgilendirme yapılır ve gerektiğinde yeniden onayınız istenir. Güncel metin ${COMPANY.webSitesi} adresinde yayımlanır.

Metin sürümü: ${LEGAL_DOC_VERSION}`;

export const USAGE_AGREEMENT_TEXT = `KULLANIM KOŞULLARI

Bu Kullanım Koşulları ("Koşullar"), ${COMPANY.unvan} ("DovizHub") ile DovizHub mobil uygulamasını kullanan kişi ("Kullanıcı") arasındaki ilişkiyi düzenler. Uygulamayı kullanarak bu Koşulları kabul etmiş olursunuz.

1. TANIMLAR
Müşteri: Döviz almak veya satmak isteyen kullanıcı.
Döviz Bürosu: Müşteri taleplerine fiyat teklifi veren, ilgili mevzuata göre faaliyet göstermeye yetkili işletme.
Talep: Müşterinin oluşturduğu döviz alım/satım isteği.
Teklif: Bir Döviz Bürosunun bir Talebe verdiği fiyat.

2. DOVIZHUB'IN ROLÜ
DovizHub bir eşleştirme platformudur. Döviz alım satımının tarafı değildir; döviz alıp satmaz, kullanıcı adına para veya döviz muhafaza etmez, ödeme aracılığı yapmaz. Kur, tutar ve şartlar Müşteri ile Döviz Bürosu arasında kararlaştırılır ve sözleşme bu iki taraf arasında kurulur. Para transferi uygulama dışında, tarafların beyan ettiği banka hesapları üzerinden yapılır.

3. UYGUNLUK VE HESAP
a) Uygulamayı yalnızca 18 yaşını doldurmuş ve fiil ehliyetine sahip kişiler kullanabilir.
b) Kayıt sırasında verdiğiniz bilgilerin doğru, güncel ve size ait olduğunu beyan edersiniz. Yanlış veya başkasına ait bilgi girilmesi hesabın kapatılması sebebidir.
c) Şifrenizin gizliliğinden siz sorumlusunuz. Hesabınızın izinsiz kullanıldığını fark ederseniz derhal ${COMPANY.destekEmail} adresine bildiriniz.
d) Döviz Bürosu profili için işletmenin ilgili mevzuata göre faaliyet gösterme yetkisi bulunmalıdır; DovizHub belge talep edebilir.

4. KUR BİLGİSİ
Uygulamada gösterilen kurlar Türkiye Cumhuriyet Merkez Bankası'nın kamuya açık günlük kur servisinden alınır ve yalnızca bilgilendirme amaçlıdır. Veri gecikmeli veya hatalı olabilir. Bu bilgiler yatırım danışmanlığı, alım-satım tavsiyesi veya fiyat taahhüdü değildir.

5. TALEP VE TEKLİF AKIŞI
a) Müşteri; döviz cinsi, tutar, yön ve banka hesabını seçerek Talep oluşturur.
b) Talep, ilgili Döviz Bürolarına bildirim olarak iletilir.
c) Döviz Büroları teklif süresi içinde Teklif verir ve Tekliflerini bu süre içinde güncelleyebilir. Verilen ve güncellenen Teklifler Müşteri ekranında anlık olarak görüntülenir.
d) Müşteri, teklif süresi dolduktan sonra karar süresi içinde Tekliflerden birini seçer; seçim, teklif süresi sonunda geçerli olan fiyat üzerinden yapılır. Karar süresi içinde seçim yapılmazsa Talep kendiliğinden kapanır ve Teklifler geçersiz hale gelir.
e) Müşteri bir Teklifi kabul ettiğinde, taraflara işlemi tamamlamak için gerekli bilgiler gösterilir; seçilmeyen Döviz Bürolarına Talebin başka bir Döviz Bürosuna verildiği bildirilir.
f) Ödeme ve döviz teslimi taraflar arasında, uygulama dışında tamamlanır.
Kabul edilen Teklif taraflar için bağlayıcı bir taahhüt oluşturur; haklı sebep olmaksızın işlemden dönen kullanıcının hesabı askıya alınabilir.

6. YASAK KULLANIMLAR
Suç gelirlerinin aklanması ve terörün finansmanı ile ilişkili işlemler; başkasına ait kimlik, IBAN veya işletme bilgisi kullanmak; sahte veya yanıltıcı talep/teklif oluşturmak; fiyat manipülasyonu yapmak; uygulamayı otomatik araçlarla kullanmak, tersine mühendislik yapmak veya güvenlik önlemlerini aşmaya çalışmak; diğer kullanıcıların verilerini izinsiz toplamak yasaktır. İhlal hâlinde hesabınız bildirimsiz askıya alınabilir veya kapatılabilir.

7. BİLDİRİMLER
Talep, teklif ve işlem durumları hakkında push bildirim ve e-posta gönderilir; bunlar hizmetin işleyişine ilişkin zorunlu bildirimlerdir. Push bildirimlerini cihaz ayarlarınızdan kapatabilirsiniz. Pazarlama amaçlı ticari elektronik iletiler yalnızca ayrıca onay vermeniz hâlinde ve ilgili mevzuata uygun olarak gönderilir.

8. FİKRİ MÜLKİYET
Uygulamanın yazılımı, tasarımı, logosu ve içerikleri ${COMPANY.unvan} veya lisans verenlerine aittir. Size kişisel ve devredilemez bir kullanım lisansı verilir; kopyalama, çoğaltma, türev çalışma üretme, kiralama veya satma hakkı vermez.

9. SORUMLULUK SINIRI
Uygulama "olduğu gibi" sunulur; kesintisiz veya hatasız çalışacağı taahhüt edilmez. Mevzuatın izin verdiği ölçüde, kâr kaybı ve kur farkı gibi dolaylı zararlardan sorumlu değiliz. Kullanıcılar arasındaki işlemlerden, tarafların beyanlarının doğruluğundan ve ödeme yükümlülüklerinden DovizHub sorumlu tutulamaz. Bu madde, kasıt veya ağır ihmalden doğan sorumluluğu ve tüketici mevzuatından doğan hakları ortadan kaldırmaz.

10. FESİH VE HESAP SİLME
Koşulların ihlali, mevzuata aykırılık veya güvenlik şüphesi hâlinde hesabınız askıya alınabilir veya sonlandırılabilir. Hesabınızı dilediğiniz zaman Profil ekranındaki "Hesabımı Sil" adımıyla silebilirsiniz.

11. DEĞİŞİKLİKLER
Koşullar güncellenebilir. Önemli değişiklikler uygulama içinde duyurulur ve gerektiğinde yeniden onayınız istenir.

12. UYGULANACAK HUKUK
Bu Koşullara Türkiye Cumhuriyeti hukuku uygulanır. Tüketici sıfatını taşıyan kullanıcılar, parasal sınırlara göre Tüketici Hakem Heyetleri'ne veya Tüketici Mahkemeleri'ne başvurabilir.

13. İLETİŞİM
${COMPANY.unvan} — ${COMPANY.adres} — ${COMPANY.destekEmail}

Metin sürümü: ${LEGAL_DOC_VERSION}`;
